import { setCss } from "./utils";

export class Writer {
  private text!: string;
  public element: HTMLElement;
  private visibleSpan!: HTMLElement;
  private hiddenSpan!: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  reset() {
    // Reset visible span to empty
    this.visibleSpan.innerText = "";
  }

  setText(text: string) {
    this.text = text;
    this.element.innerHTML = "";

    // Ensure parent has relative positioning
    setCss(this.element, {
      position: "relative",
    });

    // Create hidden span with ALL text (reserves space for entire word)
    this.hiddenSpan = document.createElement("span");
    this.hiddenSpan.classList.add("hidden");
    this.hiddenSpan.innerText = text;
    setCss(this.hiddenSpan, {
      opacity: "0",
    });
    this.element.appendChild(this.hiddenSpan);

    // Create visible span (overlays hidden, shows revealed letters)
    this.visibleSpan = document.createElement("span");
    this.visibleSpan.classList.add("visible");
    setCss(this.visibleSpan, {
      position: "absolute",
      left: "0",
      top: "0",
    });
    this.element.appendChild(this.visibleSpan);
  }

  render(progress: number) {
    const totalLetters = this.text.length;
    const visibleCount = Math.floor(progress * (totalLetters + 1));

    // Show revealed letters in the visible span
    this.visibleSpan.innerText = this.text.slice(0, visibleCount);
  }
}
